import { getButtonsWithTextBoxTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";

const buttonsWithTextBoxConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Buttons With Text-Box",
    url: "/buttons-with-text-box-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getButtonsWithTextBoxTemplate(currentData),
        "buttons-with-text-box-shortcode",
      );
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");

      shortcodeWrapperEl.setAttribute("data-buttons-with-text-box-data", btoa(JSON.stringify(currentData)));

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (_, message) => {
      if (message.mceAction === "updateData") {
        currentData = message.data;
      }
    },
    width: 400,
    height: 900,
  });
};

export { buttonsWithTextBoxConfig };
